"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodeToJSON = exports.ErrorCodeFromJSONTyped = exports.ErrorCodeFromJSON = exports.instanceOfErrorCode = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ErrorCode interface.
 */
function instanceOfErrorCode(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfErrorCode = instanceOfErrorCode;
function ErrorCodeFromJSON(json) {
    return ErrorCodeFromJSONTyped(json, false);
}
exports.ErrorCodeFromJSON = ErrorCodeFromJSON;
function ErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'definition': !(0, runtime_1.exists)(json, 'definition') ? undefined : json['definition'],
    };
}
exports.ErrorCodeFromJSONTyped = ErrorCodeFromJSONTyped;
function ErrorCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'definition': value.definition,
    };
}
exports.ErrorCodeToJSON = ErrorCodeToJSON;
